import React from 'react';
import ReactDOM from 'react-dom';
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Popper, Grow, Paper, ClickAwayListener, MenuList, Avatar, Drawer, Grid, Button } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import './NavBar.css';
import Swal from 'sweetalert2';
import { createRoot } from 'react-dom/client';
import SubscriptionDetails from '../SubscriptionDetails/SubscriptionDetails';


interface NavBarTopProps { }
interface NavBarTopState {
    userDetails: UserDetailsModel,
    platformFee: boolean
    // isNotificationOpened: boolean,
    // drawerId: number,
    // isScheduleOpened: boolean
}

interface UserDetailsModel {
    accessToken: string;
    first_name: string;
    last_name: string;
    email: string;
    fullName: string;
    mobile_number: string;
}


class NavBarTop extends React.Component<NavBarTopProps, NavBarTopState> {
    constructor(props: NavBarTopProps) {
        super(props);

        this.state = {
            userDetails: {
                accessToken: '',
                fullName: '',
                email: '',
                first_name: '',
                last_name: '',
                mobile_number: ''
            },
            platformFee: false
            // isNotificationOpened: false,
            // drawerId: 0,
            // isScheduleOpened: false
        };
    }

    async componentDidMount() {
       
            this.setState({
                userDetails: {
                    accessToken: '',
                    fullName: '',
                    email: '',
                    first_name: '',
                    last_name: '',
                    mobile_number: ''
                }
            });
    }
    

    public render() {
        return (
            <div>
                <TopHeaderSource
                    userInfo={this.state.userDetails}
                    popupState={(s_) => {
                        this.setState({
                            platformFee: s_
                        })
                    }}
                />
              
            </div >
        )
    }
}

function TopHeaderSource(props: { userInfo: UserDetailsModel, popupState: (s_: boolean) => void }) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogOut = () => {
        localStorage.clear();
        window.location.href = "/";
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSetting = () => {
        setAnchorEl(null);
        if (props.popupState) {
            props.popupState(true);
        }
    };

   const handleSubscription = ()=> {
    const reactContainer = document.createElement('div');

        Swal.fire({
            title: 'Update Subscription',
            html: reactContainer,
            width: '40%',
            //showConfirmButton: true,
            showConfirmButton: false, // Important: hide default buttons
            showCancelButton: false,
            customClass: {
                popup: "custom-swal-popup", // Add custom class to the popup
              },
            didOpen: () => {
            // Render the React component into the container
            const root = createRoot(reactContainer);
            root.render(<SubscriptionDetails />);
            },
            willClose: () => {
            // Clean up the React component when Swal is closed
            if (reactContainer) {
                //reactContainer.unmount();
              }
            },
        });
    }


    const getUserProfileText = () => {
        let userAlpha = '';
        if (props.userInfo.fullName !== null && props.userInfo.fullName != '') {
            let userNameArray = props.userInfo.fullName.split(' ');
            let userAlphaList: any[] = [];

            for (let user of userNameArray) {
                userAlphaList.push(user[0]);
            }

            /*for (let i = 0; i < userNameArray.length; i++) {
                userAlphaList.push(userNameArray[i][0]);
            }*/

            userAlpha = userAlphaList.toString().replace(/,/g, '');
        }

        return userAlpha;
    }

    const stringToColor = (string: string) => {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }


    return (
        <AppBar position="static" className='top-header-container'>
            <Toolbar className='header-container'>
                <div className="header-container-sub">
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="default"
                    >
                        <Avatar className='profile-icon' style={{ background: stringToColor(getUserProfileText()) }}>{getUserProfileText()}</Avatar>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        className="profile-popup"
                        anchorEl={anchorEl}
                        elevation={0}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleSetting}>Settings</MenuItem>
                        <hr />
                        <MenuItem onClick={handleSubscription}>Change Subscription</MenuItem>
                        <hr />
                        {/* <MenuItem onClick={handleClose}>Go to prioritypassport</MenuItem> */}
                        <MenuItem onClick={handleLogOut}>Logout</MenuItem>

                    </Menu>

                </div>
            </Toolbar>
        </AppBar>
    )
}

export default NavBarTop;